import { ContentRenderer } from "@/lib/content/ContentRenderer";
import { Text } from "@mantine/core";
import classes from "./FlashCardContent.module.css";

export default function FlashCardContent({ content }: { content: any }) {
  return (
    <Text component="div" className={classes.cardContent}>
      <ContentRenderer content={content} imageContext="flashcard" />
    </Text>
  );
}
